export function checkinCompletionPercentage(
  completed: number,
  total: number,
): number {
  if (
    !Number.isFinite(completed) ||
    !Number.isFinite(total) ||
    completed < 0 ||
    total <= 0
  ) {
    return 0;
  }

  if (completed === total) {
    return 100;
  }

  return Math.min(99, Math.max(0, (completed / total) * 100));
}
